import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropertyCard from "@/components/site/PropertyCard";
import { MaskedLines } from "@/components/site/motion";
import { getProperties } from "@/lib/api";

export default function Properties() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getProperties()
            .then((d) => setItems(d))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="bg-night">
            <section
                className="pt-40 pb-16 md:pt-48 md:pb-20"
                data-testid="properties-hero"
            >
                <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-7">
                        <div className="eyebrow mb-6">The Portfolio</div>
                        <MaskedLines
                            as="h1"
                            trigger="load"
                            className="headline text-5xl md:text-7xl lg:text-[88px] text-cream leading-[1.0]"
                            lines={["Homes we", <span key="h" className="italic text-gold">host.</span>]}
                        />
                    </div>
                    <div className="lg:col-span-5 lg:col-start-8 flex items-end">
                        <p className="text-cream/55 font-light text-lg leading-relaxed">
                            A look at the properties we host under Leo&rsquo;s
                            Luxury. We&rsquo;re a young business and the portfolio
                            is growing — if you&rsquo;d like yours featured here,
                            get in touch.
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-16 md:py-20" data-testid="properties-grid-section">
                <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                    {loading ? (
                        <div className="text-cream/40 text-center py-32 font-mono uppercase tracking-[0.2em] text-xs">
                            Loading portfolio...
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-12 lg:gap-10">
                            {items.map((p, i) => (
                                <PropertyCard key={p.id} p={p} index={i} />
                            ))}
                        </div>
                    )}
                </div>
            </section>

            <section className="py-28 md:py-40 bg-night-panel relative overflow-hidden">
                <div className="grain absolute inset-0" />
                <div className="relative max-w-[1100px] mx-auto px-6 md:px-12 text-center">
                    <div className="eyebrow mb-6">Want yours on the list?</div>
                    <h2 className="headline text-4xl md:text-6xl text-cream mb-8">
                        Let&rsquo;s talk about<br />
                        <span className="italic text-gold">hosting your property.</span>
                    </h2>
                    <Link
                        to="/contact"
                        className="btn-gold inline-flex"
                        data-testid="properties-cta"
                    >
                        Apply to be Hosted
                    </Link>
                </div>
            </section>
        </div>
    );
}
